import { QueryClient } from "@tanstack/react-query";

/**
 * Shared TanStack Query client. Defaults chosen to preserve the app's existing
 * behaviour while adding caching + targeted invalidation:
 * - refetchOnWindowFocus off (the hand-rolled layer never refetched on focus)
 * - a short staleTime so navigating back is instant but data stays fresh
 * - one retry (the old layer didn't retry; one is a safe, quiet improvement)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
